import CreateSchema from './CreateSchema'
import ExportSchema from './ExportSchema'
import CopySchema from './CopySchema'
import DropSchema from './DropSchema'
import ResetSchema from './ResetSchema'
import { getAttributeValue } from '../../utils'
import CreateDatabaseUser from './CreateDatabaseUser'

export default function ManageSchemas() {
  console.log('ManageSchemas rendered')

  const attributeValue = getAttributeValue('Show All Manage Schema Options')
  const showAllManageSchemaOptions = attributeValue === 'Y' ? true : false

  let createDatabaseUser = showAllManageSchemaOptions ? <CreateDatabaseUser /> : ''
  let resetSchemaCard = showAllManageSchemaOptions ? <ResetSchema /> : ''
  let dropSchemaCard = showAllManageSchemaOptions ? <DropSchema /> : ''

  return (
    <div style={{ padding: '20px', height: '100%', overflow: 'auto'}}>
      <CopySchema />
      <CreateSchema />
      <ExportSchema />
      {createDatabaseUser}
      {dropSchemaCard}
      {resetSchemaCard}
    </div>
  )
}
